var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNarrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69727 3.53594C9.0248 3.2084 9.55584 3.2084 9.88338 3.53594L13.7543 7.4069C14.0819 7.73444 14.0819 8.26548 13.7543 8.59302L9.88338 12.464C9.55584 12.7915 9.0248 12.7915 8.69727 12.464C8.36973 12.1364 8.36973 11.6054 8.69727 11.2779L11.1365 8.83867H2.83871C2.3755 8.83867 2 8.46317 2 7.99996C2 7.53675 2.3755 7.16125 2.83871 7.16125H11.1365L8.69727 4.72205C8.36973 4.39451 8.36973 3.86347 8.69727 3.53594Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowRight);
export default __webpack_public_path__ + "static/media/arrowNarrowRight.48624b280da9aa46af8e9211301f5836.svg";
export { ForwardRef as ReactComponent };